<template>
  <div v-if="active" class="wrapper">
    <span class="separator">
      &#124;
    </span>
    <router-link :to="{name: 'podcasts.conversion', params: {id: context.id}}" class="router-link">
      <ArrowRightCircleIcon class="h-5 w-5 text-gray-100 mr-1" aria-hidden="true" />
      <span>
        Kompass-KI aktivieren
      </span>
    </router-link>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const context = computed(() => store.getters['context/context']);
const active = computed(() => ! context.value.active);
</script>

<style scoped>
.wrapper
{
  @apply inline-flex flex-row items-center;
}

.separator
{
  @apply inline-block px-6 pb-1;
  @apply text-gray-300;
}

.router-link
{
  @apply px-3 py-2 rounded-md;
  @apply text-sm font-semibold text-white;
  @apply inline-flex flex-row items-center;
  @apply hover:bg-gray-900 hover:text-white;
}

.router-link-active
{
  @apply bg-gray-900 !important;
  @apply text-white !important;
}
</style>

